import React, { Component } from "react";
import styled from "styled-components";

// Icons
import { MdSmartphone } from "react-icons/md";
import { MdTablet } from "react-icons/md";
import { MdLaptop } from "react-icons/md";

// TODO: Add option to open in new window.
// import { MdOpenInNew } from "react-icons/md";

class Toolbar extends Component {
  render() {
    const { app, catIdx, elIdx } = this.props;
    return (
      <ToolbarWrapper className="toolbar">
        <li
          onClick={() => {
            app.resizeFrame("laptop", catIdx, elIdx);
          }}
        >
          <MdLaptop />
        </li>
        <li
          onClick={() => {
            app.resizeFrame("tablet", catIdx, elIdx);
          }}
        >
          <MdTablet />
        </li>
        <li
          onClick={() => {
            app.resizeFrame("smartphone", catIdx, elIdx);
          }}
        >
          <MdSmartphone />
        </li>
      </ToolbarWrapper>
    );
  }
}

export default Toolbar;

const ToolbarWrapper = styled.ul`
  display: table;
  position: absolute;
  left: 50%;
  bottom: -20px;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  list-style: none;
  opacity: 0;
  transform: translateX(-50%) translateY(50%) translateZ(0);
  transition: transform 250ms ease, opacity 250ms ease;
  will-change: transform, opacity;

  li {
    background: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    color: #787a91;
    line-height: 35px;
    text-align: center;
    border-radius: 50%;
    margin: 0 7px 0 7px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 3px 10px rgba(0, 0, 0, 0.1);

    svg {
      top: 6px;
      position: relative;
    }

    &:hover {
      cursor: pointer;
      background: #2d53fe;
      color: #fff;
      transform: scale(1.2);
    }
  }
`;
